import React, { useState } from 'react'
import { useEffect } from 'react'
import { css, useTheme } from '@emotion/react'
import { HeaderTopBar, HeaderMiddleBar, SocialLinks } from './'
import { useDataProvider } from '../../hooks/dataProvider'
import Nav from '../webpage/Nav'
import { AiOutlineSearch } from 'react-icons/ai'
import { MediaQuery } from '../base-ui/Utility'
import useBreakpoints from '../../hooks/useBreakpoints'
import SearchModal from './SearchModal'
import { useRouter } from 'next/router'
import config from '../../../config.json'
import AdSelection from '../ads/ad_selection'

function ThemeHeader({ topBar = true, style }) {
    const theme = useTheme()
    const { locale } = useRouter()
    const backgroundColor = theme.colors.nav.backgroundColor
    const breakpoint = useBreakpoints()
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false)
    const { data, setData } = useDataProvider()
    useEffect(
        () => {
            setData({ visible: false })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    )
    const headerNavStyle = css`
        display: none;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        background-color: ${backgroundColor};
        .extra-nav {
            padding: 20px 0 16px 0px;
            position: relative;
            ${['ar', 'fa'].indexOf(locale) !== -1
            ? 'border-right: 1px solid rgba(0, 0, 0, 0.1);'
            : 'border-left: 1px solid rgba(0, 0, 0, 0.1);'}
            .extra-cell {
                display: inline-block;
                ${['ar', 'fa'].indexOf(locale) !== -1
            ? 'margin-right: 10px;'
            : 'margin-left: 10px;'}
                svg {
                    font-size: 24px;
                    color: ${theme.colors.primary};
                    font-weight: 100;
                }
            }
        }
        padding: 0 1rem;
        .social-icons {
            ${['ar', 'fa'].indexOf(locale) !== -1
            ? 'margin-right: auto;'
            : 'margin-left: auto;'}
            .link a {
                color: ${theme.colors.lightGray};
                &:hover {
                    color: ${theme.colors.secondary};
                }
            }
        }
        ${MediaQuery('lg', 'min')} {
            padding: 0rem 5rem;
            display: flex;
        }
        ${MediaQuery('xl', 'min')} {
            padding: 0rem 10rem;
        }
        ${MediaQuery('xxl', 'min')} {
            padding: 0rem 20rem;
        }
        ${style}
    `
    return (
        <header>
            {!breakpoint.xs && topBar && <HeaderTopBar />}
            <HeaderMiddleBar />
            {/* mobile Nav */}
            <div className="header-nav" css={headerNavStyle}>
                <Nav
                    items={data?.menuItems}
                    visible={mobileMenuVisible}
                    onClose={() => setMobileMenuVisible(false)}
                    type="mobile"
                />
                <div className="nav">
                    <Nav items={data?.menuItems} />
                </div>
                <AdSelection
                    ads={data?.siteAds ?? []}
                    location="site_header_menu"
                    style={{ maxHeight: 60, objectFit: 'contain' }}
                    Wrapper={({ children }) => <div style={{
                        display: 'inline-flex',
                        gap: 5,
                        alignItems: 'center',
                        maxHeight: '100%',
                        overflow: 'hidden',
                        flex: 1,
                        justifyContent: 'flex-end',
                    }}>{children}</div>}
                />
                <div className="social-icons">
                    <SocialLinks
                        socials={config?.texts?.social?.value}
                        style="justify-content: center;"
                    />
                </div>
                <div className="extra-nav">
                    <div className="extra-cell">
                        <SearchModal
                            trigger={
                                <button
                                    id="quik-search-btn"
                                    type="button"
                                    className="site-button-link"
                                >
                                    <AiOutlineSearch />
                                </button>
                            }
                        />
                    </div>
                </div>
            </div>
        </header>
    )
}

export default ThemeHeader
